export default __webpack_public_path__ + "static/3-ac5ed7ec8ea727dc9c4340d025780180.jpg";